export default {
  codigo: 'ID',
  comissao: {
    listagem: {
      codigo: 'ID'
    }
  }
};
